export var GRID_CONFIG = {
  desktop: {
    amount: 2,
    minWidth: 464
  },
  tablet: {
    amount: 2,
    minWidth: 328
  },
  mobile: {
    amount: 1,
    minWidth: 328
  }
};